import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-email-directory',
  templateUrl: './email-directory.component.html'
})
export class EmailDirectoryComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
